<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 16:27:37
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-08 16:32:55
 * @Description: 项目详情
 -->
<template>
  <div class="base-data-wrapper">
    <el-row :gutter="20" class="row">
      <el-col :span="3" class="label">
        <span>项目介绍</span>
      </el-col>
      <el-col :span="21" class="text-box">
        <!-- <p>
          本项借款用于生意周转，借款人个人资质已通过审核，
          申请信息已核实，结合资料审查和风险项综合评估，其还款能力符合要求。根据借款人当前情况评估，其还款来源能够覆盖借款本息且
          还款意愿良好。但不排除未来因宏观经济、市场产品价格波动、经营不善等因素导致借款人经营情况、财务状况恶化，从而发生逾期的可能。
        </p> -->
        <p>{{ baseInfo.projectDetail }}</p>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="3" class="label">
        <span>基本信息</span>
      </el-col>
      <el-col :span="21" class="text-box">
        <el-row :gutter="20">
          <el-col :span="5">
            <span class="item-label">项目名称：</span>
            <span class="item-text">{{ baseInfo.name }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">项目总额：</span>
            <span class="item-text">{{ baseInfo.money }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">还款方式：</span>
            <span class="item-text">{{ baseInfo.repayWay }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">起息日期：</span>
            <span class="item-text">{{ baseInfo.interestAccrual }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <span class="item-label">退出限制：</span>
            <span class="item-text">不可提前退出</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">是否有担保：</span>
            <span class="item-text">否</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="3" class="label">
        <span>借款人信息</span>
      </el-col>
      <el-col :span="21" class="text-box">
        <el-row :gutter="20">
          <el-col :span="4">
            <span class="item-label">姓名：</span>
            <span class="item-text">{{ userInfo ? userInfo.userName : '' }}</span>
          </el-col>
          <el-col :span="4">
            <span class="item-label">性别：</span>
            <span class="item-text">{{ userInfo ? userInfo.sex : '' }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">月收入：</span>
            <!-- <span class="item-text">50,000.00元以上</span> -->
            <span class="item-text">{{ userInfo ? userInfo.income : '' }}</span>
          </el-col>
          <el-col :span="4">
            <span class="item-label">所属行业：</span>
            <span class="item-text">{{ userInfo ? userInfo.industry : '' }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">证件号码：</span>
            <span class="item-text">{{ userInfo ? userInfo.identityId : '' }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <span class="item-label">借款用途：</span>
            <span class="item-text">{{ userInfo ? userInfo.usage : '' }}</span>
          </el-col>
          <el-col :span="4">
            <span class="item-label">还款来源：</span>
            <span class="item-text">个人收入</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">近6个月内征信逾期情况：</span>
            <span class="item-text">{{ userInfo ? userInfo.overdueInSixMonth : '' }}</span>
          </el-col>
          <el-col :span="4">
            <span class="item-label">借款人负债情况：</span>
            <span class="item-text">{{ userInfo ? userInfo.IsDebt : '' }}</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">借款人主体性质：</span>
            <span class="item-text">{{ userInfo ? userInfo.userType : '' }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <span class="item-label">在其他网络借贷平台借款情况：</span>
            <span class="item-text">
              {{ userInfo ? userInfo.otherLoan : '' }}（此项由借款人自述）
            </span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="3" class="label">
        <span>项目资金运用情况</span>
      </el-col>
      <el-col :span="21" class="text-box">
        <el-row :gutter="20">
          <el-col :span="5">
            <span class="item-label">项目资金运用情况：</span>
            <span class="item-text">资金运用正常</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">借款人经营情况：</span>
            <span class="item-text">无变化</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">借款人财务状况：</span>
            <span class="item-text">无变化</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">借款人逾期情况：</span>
            <span class="item-text">{{ userInfo ? userInfo.hasOverdue : '' }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <span class="item-label">借款人涉诉情况：</span>
            <span class="item-text">暂无</span>
          </el-col>
          <el-col :span="5">
            <span class="item-label">借款人还款能力变化：</span>
            <span class="item-text">无变化</span>
          </el-col>
          <el-col :span="10">
            <span class="item-label">借款人受行政处罚情况等可能影响：</span>
            <span class="item-text">暂无</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'base-data',
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {
          baseInfo: {},
          userInfo: {}
        };
      }
    }
  },
  computed: {
    baseInfo() {
      // console.log(this.propsData.baseInfo);
      return this.propsData.baseInfo;
    },
    userInfo() {
      return this.propsData.userInfo;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.base-data-wrapper {
  padding: 25px 40px 25px 20px;
  .row {
    padding: 20px 0;
    box-sizing: border-box;
  }
  .label {
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #6a6a6a;
    line-height: 26px;
  }
  .text-box {
    font-family: 'PingFangSC-Thin';
    font-size: 12px;
    color: #6a6a6a;
    line-height: 26px;
  }
}
</style>
